import React from 'react';
import { useDecryptedBoatFields } from '@/hooks/useDecryptedBoatFields';
import { useTranslation } from 'react-i18next';

interface BoatSensitiveInfoProps {
  boatId: string;
  immatriculation?: string | null;
  mmsi?: string | null;
  numero_hin?: string | null;
}

/**
 * Affiche immatriculation, MMSI et HIN déchiffrés sur la fiche d'un bateau.
 */
const BoatSensitiveInfo: React.FC<BoatSensitiveInfoProps> = ({ boatId, immatriculation, mmsi, numero_hin }) => {
  const { t } = useTranslation('boats');
  const { decrypted, loading } = useDecryptedBoatFields(boatId, { immatriculation, mmsi, numero_hin });

  const hasSensitiveFields = Boolean(immatriculation || mmsi || numero_hin);

  return (
    <>
      {loading && hasSensitiveFields && (
        <div className="flex justify-between">
          <span className="font-medium text-gray-600">{t("sensitiveInfo.identification")}</span>
          <span>{t("sensitiveInfo.decrypting")}</span>
        </div>
      )}
      {decrypted.immatriculation && (
        <div className="flex justify-between">
          <span className="font-medium text-gray-600">{t("sensitiveInfo.registration")}</span>
          <span>{decrypted.immatriculation}</span>
        </div>
      )}
      {decrypted.mmsi && (
        <div className="flex justify-between">
          <span className="font-medium text-gray-600">{t("sensitiveInfo.mmsi")}</span>
          <span>{decrypted.mmsi}</span>
        </div>
      )}
      {decrypted.numero_hin && (
        <div className="flex justify-between">
          <span className="font-medium text-gray-600">{t("sensitiveInfo.hinNumber")}</span>
          <span>{decrypted.numero_hin}</span>
        </div>
      )}
    </>
  );
};

export default BoatSensitiveInfo;
